export const WriteRight = 'WEB_MODULE_SETTINGS_PERMISSIONS_WRITE'
export const Rights = [
    WriteRight
]
